export const botLinks = {
	subscriptionNotification: "https://cp.letalk.com.br/admin/flow/19481"
}
